import React from 'react';
import { getDefaultCountryCode } from '@jutro/locale';
import loadable from '@loadable/component';
const IntlPhoneNumberInputLazy = loadable(false ? async () => require('./IntlPhoneNumberInput').IntlPhoneNumberInput : () => import('./IntlPhoneNumberInput').then(el => el.IntlPhoneNumberInput));
const IntlPhoneNumberReadOnlyLazy = loadable(false ? async () => require('./values/PhoneNumberValue').PhoneNumberValue : () => import('./values/PhoneNumberValue').then(el => el.PhoneNumberValue));
export const IntlPhoneNumberInputLazyLoaded = props => {
  return React.createElement(IntlPhoneNumberInputLazy, props);
};
export const IntlPhoneNumberReadOnlyLazyLoaded = props => {
  return React.createElement(IntlPhoneNumberReadOnlyLazy, props);
};
export function getDefaultCountry(defaultCountry) {
  let initialCountryCode = 'US';
  if (getDefaultCountryCode() && !defaultCountry) {
    initialCountryCode = getDefaultCountryCode();
  }
  if (defaultCountry) {
    initialCountryCode = defaultCountry;
  }
  return initialCountryCode;
}